import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { KENDO_INPUTS, NumericTextBoxComponent, TextBoxDirective } from '@progress/kendo-angular-inputs';
import { KENDO_LABELS } from '@progress/kendo-angular-label';
@Component({
    selector: 'gd-textbox',
    template: `
    <div [formGroup]="form" class="spacing">
      <input
        *ngIf="
          !field.multiline &&
          field.name !== 'Amount' && field.name !== 'SurrenderCharge' &&
          field.name !== 'PremiumAmount'
        "
        style="width:350px;"
        class="{{ testclass }}"
        [attr.type]="field.type"
        kendoTextBox
        [id]="field.name"
        [name]="field.name"
        [formControlName]="field.name"
      />
      <kendo-numerictextbox
        [value]="value"
        *ngIf="!field.multiline && field.name === 'Amount' || field.name === 'SurrenderCharge'"
        [format]="'c'"
        [attr.type]="field.type"
        style="width:350px;  height: calc(1.12857143em + 7px); font-size: 13px;}"
        [id]="field.name"
        [formControlName]="field.name"
        [maxlength]="maxlength"
        [spinners]="false"
        (keypress)="numberOnly($event)"
      ></kendo-numerictextbox>
      <kendo-numerictextbox
        [value]="value"
        *ngIf="!field.multiline && field.name === 'PremiumAmount'"
        [format]="'c'"
        [attr.type]="field.type"
        style="width:350px;  height: calc(1.12857143em + 7px); font-size: 13px;}"
        [id]="field.name"
        [maxlength]="maxlength"
        [formControlName]="field.name"
        [spinners]="false"
        (keypress)="numberOnly($event)"
      ></kendo-numerictextbox>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        TextBoxDirective,
        KENDO_INPUTS, KENDO_LABELS,
        NumericTextBoxComponent,
    ]
})
export class TextBoxComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  public min = 1
  public max = 5
  public maxlength = 10

  public testclass: string
  public getvalueRequired: any
  public value = 0 // default value before load. Causes Error if no default on DOM.

  constructor() {
    if (this.getvalueRequired !== undefined) {
      this.testclass =
        'ng-isolate-scope ng-invalid ng-invalid-required ng-dirty'
    }
  }

  get isValid() {
    //this.form.markAsTouched()
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    //  this.form.controls[this.field.name].markAsTouched
    return this.form.controls[this.field.name].dirty
  }
  numberOnly(event: KeyboardEvent): boolean {
    const fieldNames = ['amount', 'networth', 'liquidnetworth', 'premiumamount']

    if (fieldNames.includes(this.field.name.toLowerCase())) {
      const char = event.key
      if (
        !char.match(/[0-9.]/) ||
        (char === '.' && (event.target as HTMLInputElement).value.includes('.'))
      ) {
        event.preventDefault()
        return false
      }
    }
    return true
  }
}
